/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { TOAST_TYPE_DANGER, TOAST_TYPE_LOADING, TOAST_TYPE_SUCCESS, Toast, ToastType } from '@squiz/sds';
import { useToastStore } from 'dxpConsoleCore-mf/State';
import React from 'react';
import { DAM_STRINGS } from '../../../../../Constants/Strings.constants';

export const toastFactory = ({ type, toastContent }: { type: ToastType; toastContent?: JSX.Element }): JSX.Element => {
  const getToastTitle = (): string => {
    switch (type) {
      case TOAST_TYPE_DANGER:
        return DAM_STRINGS.error;
      case TOAST_TYPE_SUCCESS:
        return DAM_STRINGS.success;
      case TOAST_TYPE_LOADING:
        return DAM_STRINGS.loading;
      default:
        return '';
    }
  };
  const toastProps = {
    showToast: true,
    stateHandler: useToastStore,
    title: getToastTitle(),
    toastContent,
    toastType: type,
  };
  return <Toast {...toastProps} />;
};
